import { Component, input } from '@angular/core';

import { StateService } from '@uirouter/core';

import { RvSpinnerDirective } from 'src/app/components/loading/rv-spinner.directive';
import { SkeletonComponent } from 'src/app/components/skeleton/skeleton.component';
import { companyIntegrationOpenTarget } from 'src/app/settings/services/integrations/integrations-company/integrations-company.routing';
import { IntegrationsCompanyDialogsService } from 'src/app/settings/services/integrations/integrations-company/integrations-company-dialogs.service';
import {
  CompanyIntegration,
  IntegrationsCompanyService,
} from 'src/app/settings/services/integrations/integrations-company/integrations-company.service';
import { IntegrationCompanyAddCardComponent } from './integration-company-add-card/integration-company-add-card.component';

@Component({
  selector: 'integrations-company-add-section',
  templateUrl: './integrations-company-add-section.component.html',
  styleUrl: './integrations-company-add-section.component.scss',
  standalone: true,
  imports: [
    IntegrationCompanyAddCardComponent,
    RvSpinnerDirective,
    SkeletonComponent,
  ],
})
export class IntegrationsCompanyAddSectionComponent {
  /** Skeleton state owned by the parent while the shared company catalog loads. */
  readonly initialLoading = input(false);
  /** Spinner while the parent saves field-integration settings after a dialog. */
  readonly actionLoading = input(false);
  readonly integrations = this.integrationsCompanyService.available;

  constructor(
    private integrationsCompanyService: IntegrationsCompanyService,
    private integrationsCompanyDialogsService: IntegrationsCompanyDialogsService,
    private stateService: StateService,
  ) {}

  onAdd(integration: CompanyIntegration): void {
    if (this.integrationsCompanyDialogsService.needsUpgradeToAdd(integration)) {
      void this.integrationsCompanyDialogsService.promptConfigure(
        integration,
        true,
      );
      return;
    }

    const target = companyIntegrationOpenTarget(integration.id);
    void this.stateService.go(target.state, target.params);
  }
}
